<template>
  <div>
    <!-- Button Add New Sla Rule -->
    <div style="float: right">
      <loading-icon-button
        tooltip="Refresh"
        style="padding: 10px"
        @click="getSLAList"
      >
        refresh
      </loading-icon-button>
    </div>

    <data-table
      :headers="knockoutHeader"
      v-model="knockoutData"
      :items-per-page="20"
      title="SLA Rules"
      filterable
    >
    </data-table>

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
  components: {
    DataTable,
    LoadingIconButton,
    ...ValidatedInputs,
  },
  created() {
    this.getSLAList();
  },
  data() {
    return {
      error_dialog: {
        show: false,
        title: '',
        content: '',
      },
      knockoutHeader: [
        {
          text: "Application ID",
          value: "Application ID",
          search: true,
        },
        {
          text: "Email",
          value: "Email",
          search: true
        },
        {
          text: "Knock out Reason",
          value: "Knock out Reason",
        },
        {
          text: "Time",
          value: "Time",
          sort: true,
        },
      ],
        knockoutData: [],
    }
  },
  methods: {
      async getSLAList() {
        await axios.get(`/api/v1/administration/sla_knockouts`)
        .then(res => {
          this.knockoutData = res.data;
        })
        .catch(err => {
          console.log("Error getting knockoutData", err);
          this.showUserDialog("Seems like a small problem with getting data..", err.response.data.error);
        });
      },
      showUserDialog(title, message) {
        this.error_dialog.show = true;
        this.error_dialog.title = title;
        this.error_dialog.content = message;
      },
  },
  computed: {
      ...mapGetters([
      'options',
      ]),
  },
  filters: {
    ...filters
  },
};

</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
.dialogWrapper {
  padding: 30px;
}

.error-message {
  color: red;
  padding: 6px;
  margin: 15px 30px;
  text-align: center;
}
</style>